<div class="content-container min-height m-t-20" *ngIf="organization">
  <div class="spacer">
    <a class="modify-back-button" (click)="goBack()">
      {{ 'WS_DIRECTORY.ORG_MODIFY.BACK_BUTTON' | translate }}
    </a>
  </div>
  <div [formGroup]="parentForm" *ngIf="isInitForm" class="main-topic-panel wsd-detail">
    <h2>{{ (organization.name ? organization.name : 'WS_DIRECTORY.ORG_MODIFY.NEW_ORGANIZATION') | translate }}</h2>
    <p-tabView>

      <p-tabPanel
        [selected]="selectedTab === tabTypes.BASIC"
        header="{{ 'WS_DIRECTORY.ORG_MODIFY.BASIC.TAB_TITLE' | translate }}">
        <div class="ui-g">
          <div class="ui-g-9">
            <div class="ui-g">
              <div class="ui-g-offset-4 ui-g-8">
                <h3 class="m-t-0">{{ 'WS_DIRECTORY.ORG_MODIFY.TITLE' | translate}}</h3>
              </div>
            </div>
            <div class="ui-g" *gsShowIfHasPermission="['ORGANIZATION_NAME_UPDATE']">
              <div class="ui-g-4">
                <label class="label">{{ 'WS_DIRECTORY.ORG_MODIFY.NSO_NAME_LABEL' | translate }}</label>
              </div>
              <div class="ui-g-8">
                <wsd-extended-input [control]="parentForm.get('name')">
                  <input pInputText formControlName="name">
                </wsd-extended-input>
              </div>
            </div>
            <div class="ui-g" *gsShowIfHasPermission="['ORGANIZATION_NAME_FR_UPDATE']">
              <div class="ui-g-4">
                <label class="label">{{ 'WS_DIRECTORY.ORG_MODIFY.NSO_NAME_FR_LABEL' | translate }}</label>
              </div>
              <div class="ui-g-8">
                <wsd-extended-input [control]="parentForm.get('nameFr')">
                  <input pInputText formControlName="nameFr">
                </wsd-extended-input>
              </div>
            </div>
            <div class="ui-g" *gsShowIfHasPermission="['SECONDARY_NAME_UPDATE']">
              <div class="ui-g-4">
                <label class="label">{{ 'WS_DIRECTORY.ORG_MODIFY.NSO_SECONDARY_NAME_LABEL' | translate }}</label>
              </div>
              <div class="ui-g-8">
                <wsd-extended-input [control]="parentForm.get('secondaryName')">
                  <input pInputText formControlName="secondaryName">
                </wsd-extended-input>
              </div>
            </div>
            <div class="ui-g" *gsShowIfHasPermission="['SECONDARY_NAME_FR_UPDATE']">
              <div class="ui-g-4">
                <label class="label">{{ 'WS_DIRECTORY.ORG_MODIFY.NSO_SECONDARY_NAME_FR_LABEL' | translate }}</label>
              </div>
              <div class="ui-g-8">
                <wsd-extended-input [control]="parentForm.get('secondaryNameFr')">
                  <input pInputText formControlName="secondaryNameFr">
                </wsd-extended-input>
              </div>
            </div>
            <div class="ui-g" *gsShowIfHasPermission="['ORGANIZATION_TYPE_UPDATE']">
              <div class="ui-g-4">
                <label>{{ 'WS_DIRECTORY.ORG_MODIFY.ORGANIZATION_TYPE_LABEL' | translate }}</label>
              </div>
              <div class="ui-g-8">
                <wsd-select-organization-type [parentForm]="parentForm"
                                              [showLabel]="false"
                                              (onChange)="updateSubTypes()">
                </wsd-select-organization-type>
              </div>
            </div>
            <div class="ui-g" *gsShowIfHasPermission="['ORGANIZATION_SUBTYPE_UPDATE']">
              <div class="ui-g-4">
                <label>{{ 'WS_DIRECTORY.ORG_MODIFY.ORGANIZATION_SUBTYPE_LABEL' | translate }}</label>
              </div>
              <div class="ui-g-8">
                <wsd-select-organization-subtype [parentForm]="parentForm"
                                                 [showLabel]="false">
                </wsd-select-organization-subtype>
              </div>
            </div>
            <div class="ui-g" *gsShowIfHasPermission="['PARENT_ORGANIZATION_UPDATE']">
              <div class="ui-g-4">
                <label>{{ 'WS_DIRECTORY.ORG_MODIFY.PARENT_ORGANIZATION_LABEL' | translate }}</label>
              </div>
              <div class="ui-g-8">
                <wsd-select-organization-ac [parentForm]="parentForm"
                                            [showLabel]="false"
                                            [excludeOrganizations]="[organization.id]"
                                            controlName="parentOrganization">
                </wsd-select-organization-ac>
              </div>
            </div>

            <div class="ui-g" *gsShowIfHasPermission="['COUNTRY_TERRITORY_NAME_UPDATE']">
              <div class="ui-g-4">
                <label>{{ 'WS_DIRECTORY.ORG_MODIFY.COUNTRY_LABEL' | translate }}</label>
              </div>
              <div class="ui-g-8">
                <wsd-select-country [parentForm]="parentForm"
                                    [showLabel]="false">
                </wsd-select-country>
              </div>
            </div>
          </div>
          <div class="ui-g-3" style="position: relative;" *gsShowIfHasPermission="['ORGANIZATION_LOGO_UPDATE']">
            <div class="image-holder">
              <img src="../../../assets/images/no_image.png" *ngIf="!imageSrc">
              <img [src]="imageSrc" *ngIf="imageSrc">
              <button type="button"
                      (click)="removeImage()"
                      pButton
                      class="ui-button-danger remove"
                      icon="fa fa-times">
              </button>
              <p-fileUpload #fileUpload mode="basic" class="ui-button-info"
                            chooseLabel="{{ 'WS_DIRECTORY.ORG_MODIFY.LOAD_LOGO_BTN_LABEL' | translate }}"
                            accept="image/*"
                            [maxFileSize]="5000000"
                            (onSelect)="onSelect($event)">
              </p-fileUpload>
            </div>
          </div>
        </div>
      </p-tabPanel>

      <p-tabPanel [selected]="selectedTab === tabTypes.APPOINTEES"
                  *gsShowIfHasPermission="['APPOINTEES_UPDATE']"
                  header="{{ 'WS_DIRECTORY.ORG_MODIFY.APPOINTEES.TAB_TITLE' | translate }}">
        <wsd-organization-appointees [appointees]="organization.appointees">
        </wsd-organization-appointees>
      </p-tabPanel>

      <p-tabPanel [selected]="selectedTab === tabTypes.CONTACTS"
                  *gsShowIfHasPermission="['CONTACTS_ORGANIZATION_UPDATE']"
                  header="{{ 'WS_DIRECTORY.ORG_MODIFY.CONTACTS.TAB_TITLE' | translate }}">
        <wsd-contacts [contacts]="organization.contacts"
                      [addresses]="organization.addresses"
                      [countryId]="organization.country?.id"
                      [isOrganization]=true
        >
        </wsd-contacts>
      </p-tabPanel>

      <p-tabPanel [selected]="selectedTab === tabTypes.DETAIL"
                  header="{{ 'WS_DIRECTORY.ORG_MODIFY.DETAIL_INFO.TAB_TITLE' | translate }}">
        <wsd-organization-detail-information [parentForm]="parentForm">
        </wsd-organization-detail-information>
      </p-tabPanel>

      <p-tabPanel [selected]="selectedTab === tabTypes.REPORTING"
                  header="{{ 'WS_DIRECTORY.ORG_MODIFY.REPORTING.TAB_TITLE' | translate }}">
        <wsd-organization-reporting [parentForm]="parentForm">
        </wsd-organization-reporting>
      </p-tabPanel>

      <p-tabPanel [selected]="selectedTab === tabTypes.CONSTITUTION"
                  header="{{ 'WS_DIRECTORY.ORG_MODIFY.CONST_POLICIES.TAB_TITLE' | translate }}">
        <wsd-organization-constitution [parentForm]="parentForm">
        </wsd-organization-constitution>
      </p-tabPanel>

      <p-tabPanel [selected]="selectedTab === tabTypes.INTERACTIONS"
                  *gsShowIfHasPermission="['ORGANIZATION_INTERACTIONS_READ']"
                  header="{{ 'WS_DIRECTORY.ORG_MODIFY.INTERACTIONS.TAB_TITLE' | translate }}">
        <wsd-organization-interactions (onNewInteraction)="saveInteractions()" (onInteractionDelete)="saveInteractions()"
                                       [interactions]="organization.interactions">
        </wsd-organization-interactions>
      </p-tabPanel>
      <p-tabPanel [selected]="selectedTab === tabTypes.WIDGETS"
                  *gsShowIfHasPermission="['NDP_CUSTOM_WIDGETS_READ']"
                  header="{{ 'WS_DIRECTORY.ORG_MODIFY.CUSTOM_WIDGETS.TAB_TITLE' | translate }}">
        <wsd-organization-custom-widgets [widgets]="organization.widgets" (onNewWidget)="saveWidgets()" [parentForm]="parentForm"
                                         (onWidgetDelete)="saveWidgets()" [organizationId]="organization.id">

        </wsd-organization-custom-widgets>
      </p-tabPanel>

    </p-tabView>

    <hr>

    <div class="ui-g m-b-0">

      <div class="ui-g-12">

        <button pButton *gsShowIfHasPermission="['ORGANIZATION_UPDATE']"
                class="ui-button-success m-l-10 fright"
                label="{{ 'WS_DIRECTORY.ORG_MODIFY.SAVE_BUTTON' | translate }}"
                [disabled]="isSaveDisabled"
                (click)="save()">
        </button>
      </div>
    </div>
  </div>
</div>

<p-confirmDialog appendTo="body" icon="fa fa-question-circle" [style]="{width: '425px'}"></p-confirmDialog>

<p-blockUI [blocked]="block">
  <div class="wrapper">
    <h4>{{ 'WS_DIRECTORY.ORG_MODIFY.INTERACTIONS.PLEASE_WAIT' | translate }}</h4>
    <i class="fa fa-spinner fa-spin fa-3x"></i>
  </div>
</p-blockUI>
